import { PhoneNumber } from "univapay-node";

/**
 * Validates a phone number object.
 *
 * @param {PhoneNumber} phoneNumber - The phone number object to validate.
 * @returns {boolean} - Returns false if the phone number is valid, otherwise true.
 *
 * Invalid if:
 * - The local number contains other characters than digits and spaces
 * - The local number (not included spaces) has a length less than 4
 */
export const validatePhoneNumber = (phoneNumber: PhoneNumber) => {
    const localNumber = phoneNumber?.localNumber?.replace(/ /g, "");

    if (!phoneNumber || !localNumber) {
        return false;
    }

    if (!/^[0-9]+$/.test(localNumber)) {
        return true;
    }

    return localNumber.length < 4 || localNumber.length > 15;
};

/**
 * Formats a phone number object.
 *
 * @param {PhoneNumber} phoneNumber - The phone number object to validate.
 * @returns {PhoneNumber} - Returns a phone number with the localNumber spaces removed.
 *
 */
export const formatPhoneNumber = (phoneNumber: PhoneNumber) => {
    const formatted = phoneNumber?.localNumber?.replace(/\s+/g, "");

    return {
        phoneNumber: {
            countryCode: phoneNumber?.countryCode || (formatted ? "81" : undefined),
            localNumber: formatted,
        },
    };
};
